// Fonction pour convertir un titre en slug
export const titleToSlug = (title) => {
  return title
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Supprimer les accents
    .replace(/[^a-z0-9\s\-.,x]/g, '') // Garder lettres, chiffres, espaces, tirets, points, virgules et x
    .replace(/\s+/g, '-') // Remplacer les espaces par des tirets
    .replace(/-+/g, '-') // Remplacer les tirets multiples par un seul
    .replace(/\./g, '') // Supprimer les points après avoir traité les espaces
    .replace(/,/g, '') // Supprimer les virgules après avoir traité les espaces
    .trim()
}

// Fonction pour générer l'URL d'un produit
export const getProductUrl = (product) => {
  if (!product || !product.name) return '#'
  const slug = titleToSlug(product.name)
  return `/catalogue-location-materiel-tournage-guadeloupe/${slug}`
}

// Fonction pour générer l'URL d'un produit à partir de son nom et ID
export const getProductUrlFromName = (name, id) => {
  if (!name) return '#'
  const slug = titleToSlug(name)
  return `/catalogue-location-materiel-tournage-guadeloupe/${slug}`
}
